import { isSsr } from "shared/lib/utils";

export const getLocalstorageExtraInformation = () => {
  if (isSsr()) return {};
  return Object.entries(localStorage).reduce(
    (accumulator, [key, value]) => {
      accumulator[key] = new Blob([value]).size;
      return accumulator;
    },
    {} as Record<string, unknown>,
  );
};
